<template>
  <div class="churn-popup">
    <popup :buttons="buttons" :close-action="closeAction" :back-action="backAction ">
      <template v-slot:title>
        <div>סגירת חשבון</div>
        <div>ומחיקת פרטים</div>
      </template>
      <template v-slot:content>
        <slot name="popup-content"></slot>
      </template>
    </popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';

export default {
  name: 'ChurnPopup',
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    closeAction: {
      type: Function,
      required: false,
    },
    backAction: {
      type: Function,
      required: false,
    },
  },
  components: {
    Popup: BaseUI.Popup,
  },
};
</script>

<style lang="scss" scoped>
</style>
